import ApplicationAdapter from './application';

export default class AgreementAdapter extends ApplicationAdapter {
  pathForType() {
    return 'agreements';
  }
}
